import { IIconColor } from "../../models/Colors";
import { Theme, makeWeStyles } from "../../themes/util";

export const VARIANTS = {
	medium: 20,
	large: 24,
	"x-large": 32,
} as const;

export type IColor = keyof IIconColor | "none";

export type IVariants = keyof typeof VARIANTS;

interface IStyleProps {
	variant?: IVariants;
	color?: IColor;
	fill?: string;
}

export const useStyles = makeWeStyles<Theme, IStyleProps>(theme => ({
	Root: {
		fontSize: ({ variant }) => VARIANTS[variant ?? "medium"],
		lineHeight: ({ variant }) => VARIANTS[variant ?? "medium"],
		height: ({ variant }) => VARIANTS[variant ?? "medium"],
		width: ({ variant }) => VARIANTS[variant ?? "medium"],
		color: ({ color }) => color && theme.bento.colors.Icon[color as keyof IIconColor],
		fill: ({ fill }) => (fill ? fill : "currentColor"),
		"& path": {
			// fill: theme.bento.colors.Icon.primary,
		},
	},
}));
